const API_URL = process.env.REACT_APP_API_URL;

export class ApiError extends Error {
  constructor(message, status, code) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

function getAccessToken() {
  return sessionStorage.getItem("access_token");
}

export function setTokens(accessToken, refreshToken) {
  sessionStorage.setItem("access_token", accessToken);
  sessionStorage.setItem("refresh_token", refreshToken);
}

export function clearTokens() {
  sessionStorage.removeItem("access_token");
  sessionStorage.removeItem("refresh_token");
}

export async function apiRequest(path, options = {}) {
  const { method = "GET", body, auth = false } = options;

  const headers = {
    "Content-Type": "application/json",
  };

  if (auth) {
    const token = getAccessToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok || data?.success === false) {
    const message =
      data?.error?.message || "Something went wrong. Please try again.";
    const code = data?.error?.code;
    throw new ApiError(message, res.status, code);
  }

  return data?.data;
}
